import React from "react";
import { Col } from "reactstrap";

const BreadCrumb = ({ title }) => {
  return (
    <Col xs={12} md={12} lg={12} className="sticky-breadcrumb-wrapper">
      <div className="sticky-title page-title-box">
        <h4 className="mb-sm-0">{title}</h4>
      </div>
    </Col>
  );
};

export default BreadCrumb;
